
export const config = {
    apiKey: "AIzaSyA9Vxp8Vot-ltvH7kZpRGmqM4WWGcTNaug",
    authDomain: "three-message.firebaseapp.com",
    projectId: "three-message",
    storageBucket: "three-message.appspot.com",
    messagingSenderId: "792215781915",
    appId: "1:792215781915:web:a51bdd00b55d709cb3aebe"
  };